import { LegalPage } from '@/components/legal/LegalPage'
import { privacyPolicy } from '@/content/legal'

export function Privacy() {
  return <LegalPage doc={privacyPolicy} path="/privacy" />
}
